<template>
  <div class="ac-gen-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex><strong>公式：</strong>详见下方原理说明</div>
    </div>

    <div class="main-stage">
      <!-- 物理模型 -->
      <div class="scene">
        <svg width="200" height="200" viewBox="0 0 200 200">
          <!-- 磁铁 -->
          <rect x="0" y="50" width="40" height="100" fill="#ff4757" /> <text x="10" y="110" fill="#fff">N</text>
          <rect x="160" y="50" width="40" height="100" fill="#2f3542" /> <text x="170" y="110" fill="#fff">S</text>
          
          <!-- 磁感线 -->
          <line v-for="i in [70, 90, 110, 130]" :key="i" x1="40" :y1="i" x2="160" :y2="i" stroke="#555" stroke-dasharray="2,2" />

          <!-- 旋转线圈 (投影视角) -->
          <g transform="translate(100, 100)">
            <ellipse cx="0" cy="0" :rx="coilX" :ry="60" fill="none" stroke="#ffff00" stroke-width="3" />
            <line x1="0" y1="-60" x2="0" y2="60" stroke="#aaa" stroke-width="1" stroke-dasharray="4,4" /> <!-- 轴 -->
          </g>
        </svg>
      </div>

      <!-- 波形图 -->
      <div class="graph">
        <svg width="250" height="150" viewBox="0 0 250 150">
          <line x1="0" y1="75" x2="250" y2="75" stroke="#444" />
          <path :d="sinePath" fill="none" stroke="#2ed573" stroke-width="2" />
          <circle :cx="200" :cy="currentY" r="4" fill="#ff4757" />
        </svg>
      </div>
    </div>

    <div class="instant-val">
       瞬时电动势 e = Emsin(ωt) = {{ currentE.toFixed(1) }} V
    </div>
  </div>
</template>

<script>
export default {
  name: 'ACGeneratorViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      angle: 0,
      speed: 3,
      history: []
    }
  },
  computed: {
    coilX() {
      // 模拟投影宽度
      return Math.abs(60 * Math.cos(this.angle));
    },
    currentE() {
      return 50 * Math.sin(this.angle);
    },
    currentY() {
      return 75 - this.currentE;
    },
    sinePath() {
      let d = "M 0 75";
      for (let i = 0; i <= 200; i++) {
        const a = this.angle - (200 - i) * 0.05;
        const y = 75 - 50 * Math.sin(a);
        d += ` L ${i} ${y}`;
      }
      return d;
    }
  },
  mounted() {
    this.animate();
  },
  beforeDestroy() { cancelAnimationFrame(this.timer); },
  methods: {
    animate() {
      this.angle += this.speed * 0.02;
      this.timer = requestAnimationFrame(this.animate);
    }
  }
}
</script>

<style scoped lang="scss">
.ac-gen-viz { width: 100%; color: #fff; display: flex; flex-direction: column; gap: 10px; }
.viz-header { display: flex; justify-content: space-between; padding: 10px; background: rgba(255,255,255,0.05); }
.main-stage { display: flex; align-items: center; justify-content: space-around; background: #0a0a0a; border-radius: 8px; padding: 10px; }
.instant-val { text-align: center; color: #2ed573; font-family: monospace; font-size: 1.1rem; padding: 10px; }
</style>
